// Navigateurs intégrés des applis (Facebook, Messenger, Instagram...) : le paiement
// HelloAsso y échoue souvent à l'étape de validation bancaire (3D Secure, bascule vers
// l'appli de la banque), et leur stockage est effacé à la fermeture de la page, d'où un
// joueur déconnecté à chaque nouvel essai.
const IN_APP_PATTERNS: [RegExp, string][] = [
  [/FBAN|FBAV|FB_IAB|FBIOS/i, 'Facebook'],
  [/Messenger/i, 'Messenger'],
  [/Instagram/i, 'Instagram'],
  [/musical_ly|BytedanceWebview|TikTok/i, 'TikTok'],
  [/Snapchat/i, 'Snapchat'],
  [/LinkedInApp/i, 'LinkedIn'],
  [/WhatsApp/i, 'WhatsApp'],
  [/\bLine\//i, 'Line'],
]

/** Nom de l'appli dont le navigateur intégré affiche la page, null sinon. */
export function inAppBrowserName(ua: string = navigator.userAgent): string | null {
  for (const [re, name] of IN_APP_PATTERNS) {
    if (re.test(ua)) return name
  }
  return null
}

export const isAndroid = (ua: string = navigator.userAgent) => /Android/i.test(ua)

/** Lien qui force l'ouverture de l'URL dans Chrome sur Android (sans équivalent iOS). */
export function chromeIntentUrl(url: string): string {
  const u = new URL(url)
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=${u.protocol.replace(':', '')};package=com.android.chrome;end`
}
